import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import UserBadge from 'components/Header/UserBadge';
import { currentUserSelectors } from '@lifesize/nucleus';

const mapStateToProps = (state) => {
  const myInfo = currentUserSelectors.myInfo(state);

  return {
    isAvailable: !myInfo.doNotDisturb,
    myExtension: myInfo.dialString,
    myInviteUrl: myInfo.inviteURL,
    myName: myInfo.name
  };
};

export default injectIntl(connect(mapStateToProps)(UserBadge));
